//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action

import * as guideAction from '../action/guideAction';

//Material-ui
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';

import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';


//Icon
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ClearIcon from '@material-ui/icons/Clear';
import ChangeHistoryIcon from '@material-ui/icons/ChangeHistory';
import CloseIcon from '@material-ui/icons/Close';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


class Comp extends React.Component {

  constructor(props) {
		super(props);

    this.state = {
      tabValue: props.tabValue,
    }
	}

	render() {

    let compMen = (
      <div>
        <div style={{margin:'15px'}} align='center'>
          <div className='round12 shadow' style={{background:'#A6BDD5', maxWidth:'560px'}}>
            <div style={{padding:'10px'}}>
              <div style={{fontSize:'1.6em', fontWeight:'bold', color:'#073E77'}} align='center'>男性</div>
              <div align='center' style={{color:'#073E77', fontWeight:'bold', position:'relative'}}>
                <span style={{fontSize:'2em'}} className='text_border_white i-b'>￥1980～</span>
                <span style={{fontSize:'0.9em'}} className='i-b'>30日換算</span>
              </div>
              <div align='center'>
                <span className='orange_icon'>業界最安値</span>
                <span className='blue_icon'>ポイント等の追加料金一切なし</span>
              </div>
              <div align='center' style={{padding:'3px'}}>
                <span className='i-b'>無料サービスでもお相手1人につき</span>
                <span className='i-b'>最大5通まで無料メールが送信できます</span>
              </div>
            </div>
          </div>
        </div>

        <div style={{margin:'15px'}}>
          <div
            width='100%'
            id='payment_comparison_table'
            style={{border:'1px solid #E5E5E5', background:'#FFF'}}
            className='shadow'
          >

            <div className='tr'>
              <div className='th' style={{width:'25%', minWidth:'100px'}}>
              </div>
              <div className='th' style={{width:'25%', background:'#A6BDD5', textAlign:'center', color:'#073E77'}}>
                無料
              </div>
              <div className='th' style={{width:'25%', background:'#4376AB', textAlign:'center', color:'#FFF'}}>
                有料
              </div>
            </div>
            <div className='tr'>
              <div className='td'>
                会員検索
              </div>
              <div className='td judgment'>
                <CheckCircleIcon className='icon ok'/>
              </div>
              <div className='td judgment'>
                <CheckCircleIcon className='icon ok'/>
              </div>
            </div>
            <div className='tr'>
              <div className='td'>
                プロフの閲覧
              </div>
              <div className='td judgment'>
                <CheckCircleIcon className='icon ok'/>
              </div>
              <div className='td judgment'>
                <CheckCircleIcon className='icon ok'/>
              </div>
            </div>
            <div className='tr'>
              <div className='td'>
                メール送信
              </div>
              <div className='td judgment' style={{position:'relative'}}>
                <ChangeHistoryIcon className='icon both' />
                <div style={{fontSize:'0.7em'}}>
                  <span className='i-b'>お相手様1人に</span>
                  <span className='i-b'>最大5通まで</span>
                </div>
              </div>
              <div className='td judgment'>
                <CheckCircleIcon className='icon ok'/>
              </div>
            </div>
            <div className='tr'>
              <div className='td'>
                メール受信
              </div>
              <div className='td judgment'>
                <CheckCircleIcon className='icon ok'/>
              </div>
              <div className='td judgment'>
                <CheckCircleIcon className='icon ok'/>
              </div>
            </div>
            <div className='tr'>
              <div className='td'>
                カップリング
              </div>
              <div className='td judgment'>
                <ClearIcon className='icon ng'/>
              </div>
              <div className='td judgment'>
                <CheckCircleIcon className='icon ok'/>
              </div>
            </div>
            <div className='tr'>
              <div className='td'>
                連絡先の交換
              </div>
              <div className='td judgment'>
                <ClearIcon className='icon ng'/>
              </div>
              <div className='td judgment'>
                <CheckCircleIcon className='icon ok'/>
              </div>
            </div>
          </div>

        </div>

        <div style={{margin:'15px'}}>
          <div style={{fontSize:'0.9em',color:'#666'}}>
            無料メールでアプローチしてお返事があった際に、有料サービスにお申込みいただければ、無駄な費用が掛からずに活動いただけます。
          </div>
        </div>

        <div style={{margin:'15px'}}>
          <h3>無料サービスのメール</h3>
          <ul style={{margin:'5px 5px 5px 25px',color:'#333'}}>
            <li>各証明書を申請される毎に最大送信数が増え、お相手１人につき５通まで送ることができます。</li>
            <li>最大100文字に制限されます。</li>
            <li>送信後に審査が完了してからお相手に送信される為、タイムラグがあります。</li>
            <li>お相手の希望条件と著しく異なる場合、送信できません。</li>
            <li>連絡先の交換は行えません。(受信された連絡先は伏字になります)</li>
          </ul>
        </div>
        <div style={{margin:'15px'}}>
          <h3>有料サービスのメール</h3>
          <ul style={{margin:'5px 5px 5px 25px',color:'#333'}}>
            <li>人数制限、送信数に制限はありません。</li>
            <li>最大1000文字まで記入できます。</li>
            <li>審査はなくリアルタイムにお相手様に送信されます。</li>
            <li>お相手の希望条件による制限はなく、どなたにでも送信できます。</li>
            <li>連絡先の交換も自由に行っていただけます。</li>
          </ul>
        </div>
      </div>
    )

    let compWomen = (
      <div>
        <div style={{margin:'15px'}} align='center'>
          <div className='round12 shadow' style={{background:'#E7B0D0', maxWidth:'560px'}}>
            <div style={{padding:'10px'}}>
              <div style={{fontSize:'1.6em', fontWeight:'bold', color:'#920056'}} align='center'>女性</div>
              <div align='center' style={{fontWeight:'bold', color:'#920056', textShadow:'0px 1px 1px #FFF'}}>
                <span style={{fontSize:'2em'}} className='text_border_white i-b'>￥0 完全無料</span>
              </div>
              <div align='center'>
                <span className='red_icon'>
                  <span className='i-b'>メール送信からご成婚まで</span>
                  <span className='i-b'>一切料金は発生いたしません</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div style={{margin:'15px'}}>
          <div
            width='100%'
            id='payment_comparison_table'
            style={{border:'1px solid #E5E5E5', background:'#FFF'}}
            className='shadow'
          >

            <div className='tr'>
              <div className='th' style={{width:'25%', minWidth:'100px'}}>
              </div>
              <div className='th' style={{width:'25%', background:'#CD4695', textAlign:'center', color:'#FFF'}}>
                無料
              </div>
            </div>
            <div className='tr'>
              <div className='td'>
                会員検索
              </div>
              <div className='td judgment'>
                <CheckCircleIcon className='icon ok'/>
              </div>
            </div>
            <div className='tr'>
              <div className='td'>
                プロフの閲覧
              </div>
              <div className='td judgment'>
                <CheckCircleIcon className='icon ok'/>
              </div>
            </div>
            <div className='tr'>
              <div className='td'>
                メール送信
              </div>
              <div className='td judgment'>
                <CheckCircleIcon className='icon ok'/>
              </div>
            </div>
            <div className='tr'>
              <div className='td'>
                メール受信
              </div>
              <div className='td judgment'>
                <CheckCircleIcon className='icon ok'/>
              </div>
            </div>
            <div className='tr'>
              <div className='td'>
                カップリング
              </div>
              <div className='td judgment'>
                <CheckCircleIcon className='icon ok'/>
              </div>
            </div>
            <div className='tr'>
              <div className='td'>
                連絡先の交換
              </div>
              <div className='td judgment'>
                <CheckCircleIcon className='icon ok'/>
              </div>
            </div>
          </div>
        </div>
        <div style={{margin:'15px'}}>
          登録から交際・御成婚まで一切料金は発生いたしません。<br/>
          (年齢確認のご本人様証明書は必須)<br/>
        </div>
      </div>
    )


		return (
      <Dialog
        fullScreen
        open={this.props.guide.payment.visible}
        onClose={ () => this.props.guidePaymentSet(false, null) }
        TransitionComponent={Transition}
        style={{maxWidth:'600px', margin:'auto'}}
        scroll='paper'
      >
        <div style={{width:'100%',zIndex:'100'}} className='shadow'>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent: 'space-between',
            }}
          >
            <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
              料金のご案内
            </div>
            <div>
              <IconButton onClick={ () => this.props.guidePaymentSet(false, null) }>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </div>

        <DialogContent style={{padding:'10px'}}>
        {
          (this.props.guide.payment.tab) && (
            <div
              style={{
                width:'100%',
                background:'#FFF',
              }}
            >
              <Box boxShadow={2} style={{margin:'15px'}}>
                <Tabs
                  value={this.props.guide.payment.tab}
                  onChange={ (e, value) => this.props.guidePaymentSet(true, value) }
                  indicatorColor="primary"
                  variant="fullWidth"
                >
                  <Tab
                    value="men"
                    label="男性"
                    style={{fontSize:'1em',fontWeight:'bold'}}
                  />
                  <Tab
                    value="women"
                    label="女性"
                    style={{fontSize:'1em',fontWeight:'bold'}}
                  />
                </Tabs>
              </Box>
              <div style={{paddingTop:'10px'}}>
                {
                  (this.props.guide.payment.tab === 'men') && (
                    compMen
                  )
                }
                {
                  (this.props.guide.payment.tab === 'women') && (
                    compWomen
                  )
                }
              </div>
            </div>
          )
        }
        </DialogContent>
      </Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		guide: state.guide,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...guideAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
